import React, { useEffect, useRef, useState } from "react";
import "./AboutSection.css";

import paperBg from "../../assets/Group14.png";
import roseImg from "../../assets/rose.png";
import notePaper from "../../assets/textgroup.png";

const AboutSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentSection = sectionRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(currentSection);
        }
      },
      {
        threshold: 0.25,
      }
    );

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  return (
    <section
      className={`aboutSection ${isVisible ? "showSection" : ""}`}
      id="about"
      ref={sectionRef}
    >
      <div className="aboutPaperWrap">
        <img
          src={paperBg}
          alt="paper background"
          className="aboutPaperBg"
        />

        <div className="aboutTextBlock">
          <h3 className="aboutSmallTitle">About Abdel Halim</h3>
          <h2 className="aboutMainTitle">The Voice That Defined an Era</h2>

          <p className="aboutParagraph">
            Abdel Halim Hafez was one of the most iconic voices in the history
            of Arabic music. Known as{" "}
            <span className="aboutHighlight">“The Brown Nightingale,”</span> he
            captivated millions with his emotional performances and romantic
            songs.
          </p>

          <p className="aboutParagraph aboutParagraphSecond">
            Emerging during the golden age of Egyptian cinema and music in the
            1950s, Abdel Halim became a cultural icon whose voice carried the
            feelings of an entire generation.
          </p>
        </div>

     

        <div className="aboutImageGroup">
      
        </div>

        <div className="aboutBottomNoteWrap">
          <img
            src={notePaper}
            alt="Arabic note paper"
            className="aboutBottomNote"
          />
        </div>

        <img
          src={roseImg}
          alt="rose"
          className="aboutRose"
        />
      </div>
    </section>
  );
};

export default AboutSection;